import React, { useEffect,useState } from 'react';
import { getDataSession, validarExisteSucursalPrincipal } from 'views/Utils/Common';
import ListTable from 'components/table/ListTable'
import { fetchConToken } from 'helpers/fetch';
import RenderButtons from 'components/table/RenderButtons';
import TextField from '@mui/material/TextField';
import Swal from 'sweetalert2';
import AsyncSelect from 'react-select/async';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import { useUIUtils } from 'hooks/useUIUtils';

const List = ({ match, saludo, subtitulo }) => {
    const {changeGlobalTitle} = useUIUtils()
    let [fechaInicio, setFechaInicio] = useState(GetFecha(true));
    let [fechaFin, setFechaFin] = useState(GetFecha(false));
    const { path } = match;
    let [almacenId, setAlmacenId] = useState(0);
    let [articuloId, setArticuloId] = useState(0);
    let [tipoMov, setTipoMov] = useState("");
    console.log(fechaInicio, fechaFin)

    const columns = [
        { renderCell: RenderButtons, headerName: '', maxWidth: 20, path: path, opciones: "ver" },
        { field: 'id', headerName: 'Id', width: 70 },
        { field: 'movimiento', headerName: 'Movimiento', flex: 1 },
        { field: 'unidades', headerName: 'Uni. Mov.', flex: 1 },
        { field: 'existencia_Anterior', headerName: 'Exist. Ant.', flex: 1 },
        { field: 'existencia_Nueva', headerName: 'Exist. Nue.', flex: 1 },
        { field: 'articulo', headerName: 'Articulo', flex: 1 },
        { field: 'variante', headerName: 'Variante', flex: 1},
        { field: 'almacen', headerName: 'Almacen', flex: 1 },
        { field: 'fecha_Registro', headerName: 'Fecha', flex: 1 },
        { field: 'usuario', headerName: 'Usuario', flex: 1 },

    ];

    useEffect(() => { 
        changeGlobalTitle('Historial de movimientos de entrada', 'Todas las entradas de articulos')
        validarExisteSucursalPrincipal();
     }, [changeGlobalTitle]);

      const handleInputChangeFechaInicio = ({ target }) => {
        setFechaInicio(target.value);
    };

 const handleInputChangeFechaFin = ({ target }) => {
        setFechaFin(target.value);
    }

    function GetFecha(inicio) {
        const now = new Date();

        if (inicio) {
            return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
        } else {
            const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
            return `${lastDay.getFullYear()}-${String(lastDay.getMonth() +1).padStart(2, '0')}-${String(lastDay.getDate()).padStart(2, '0')}`;
        }
    }

     const loadAlmacenes = async (query) => {
            if (getDataSession('sucursal') === '0') {
                Swal.fire('Info', 'Seleccione una conexión para continuar.', 'info');
                return;
            }
    
            var resp = await fetchConToken(`almacenes/GetList?paginas=0&totalXpagina=50&busqueda=${query}&sucursal_Id=${getDataSession('sucursal')}`);
            return resp.data;
        };

         const loadArticulos = async (query) => {
            if (getDataSession('sucursal') === '0') {
                Swal.fire('Info', 'Seleccione una conexión para continuar.', 'info');
                return;
            }
    
            var resp = await fetchConToken(`Articulos/GetList?paginas=0&totalXpagina=50&busqueda=${query}&sucursal_Id=${getDataSession('sucursal')}`);
            return resp.data;
        };
        const handleChangeTipoMov = ({ target }) => {
        setTipoMov(target.value);
    }
    return (
        <>
            <div className='container-fluid'>
                <div className='col-12 col-sm-12 col-md-12 row'>
                    <div className='col-md-12 row'>
                                        <div className='col-md-3'>
                                            <FormControl fullWidth sx={{ m: 1, minWidth: 120 }} size="small">
                                                                       <AsyncSelect
                                                              placeholder='&nbsp; almacen'
                                                              aria-label='almacen'
                                                              isClearable
                                                              getOptionLabel={(option) =>  option.nombre }
                                                              getOptionValue={(option) => option.id}
                                                              loadOptions={loadAlmacenes}
                                                              onChange={(selectedItem) => {
                                                                  setAlmacenId((selectedItem !== undefined && selectedItem !== null) ? selectedItem?.id.toString() : 0);
                                                              }}
                                                          />
                                                                    </FormControl>
                                                       
                                                          
                                                      </div>
                                                             <div className='col-md-3'>
                                                           <FormControl fullWidth sx={{ m: 1, minWidth: 120 }} size="small">
                                                          <AsyncSelect
                                                              placeholder='&nbsp; articulo'
                                                              aria-label='articulo'
                                                              isClearable
                                                              getOptionLabel={(option) =>  option.nombre }
                                                              getOptionValue={(option) => option.id}
                                                              loadOptions={loadArticulos}
                                                              onChange={(selectedItem) => {
                                                                  setArticuloId((selectedItem !== undefined && selectedItem !== null) ? selectedItem?.id.toString() : 0);
                                                              }}
                                                          />
                                                           </FormControl>
                                                      </div>
                                      <div className='col-md-2'>
                                          <TextField fullWidth sx={{ m: 1, minWidth: 120 }} size="small"
                                              id="filled-number"
                                              label="Fecha Inicio"
                                              type="date"
                                              value={fechaInicio}
                                              onChange={handleInputChangeFechaInicio}
                                              InputLabelProps={{ shrink: true, }}
                                          />
                                      </div>
                                      <div className='col-md-2'>
                                          <TextField fullWidth sx={{ m: 1, minWidth: 120 }} size="small"
                                              id="filled-number"
                                              label="Fecha Fin"
                                              type="date"
                                              value={fechaFin}
                                              onChange={handleInputChangeFechaFin}
                                              InputLabelProps={{ shrink: true, }}
                                          />
                                      </div>
                                        <div className='col-md-2'>
                                                              <FormControl fullWidth sx={{ m: 1, minWidth: 120 }} size="small">
                                                                  <InputLabel id="estatus-label">Tipo movimiento</InputLabel>
                                                                   <Select label="Tipo Fecha" value={tipoMov} onChange={handleChangeTipoMov}>
                                                                            <MenuItem key='COMPRA' value='COMPRA'><ListItemText primary='COMPRA' /></MenuItem>
                                                                        <MenuItem key='CANCELACION-VENTA' value='CANCELACION-VENTA'><ListItemText primary='CANCELACION VENTA' /></MenuItem>
                                                                        <MenuItem key='INVENTARIO-COMPRA' value='INVENTARIO-COMPRA'><ListItemText primary='INVENTARIO COMPRA' /></MenuItem>
                                                                        <MenuItem key='INVENTARIO-RECEPCION-MERCANCIA' value='INVENTARIO-RECEPCION-MERCANCIA'><ListItemText primary='INVENTARIO RECEPCION MERCANCIA' /></MenuItem>
                                                                        <MenuItem key='INVENTARIO-DEVOLUCION-VENTA' value='INVENTARIO-DEVOLUCION-VENTA'><ListItemText primary='INVENTARIO DEVOLUCION VENTA' /></MenuItem>
                                                                        <MenuItem key='INVENTARIO-TRASPASO-ENTRADA' value='INVENTARIO-TRASPASO-ENTRADA'><ListItemText primary='INVENTARIO TRASPASO ENTRADA' /></MenuItem>
                                                                        <MenuItem key='INVENTARIO-FISICO-ENTRADA' value='INVENTARIO-FISICO-ENTRADA'><ListItemText primary='INVENTARIO FISICO ENTRADA' /></MenuItem>
                                                                        <MenuItem key='INVENTARIO-AJUSTE-ENTRADA' value='INVENTARIO-AJUSTE-ENTRADA'><ListItemText primary='INVENTARIO AJUSTE ENTRADA' /></MenuItem>
                                                                        <MenuItem key='INVENTARIO-SALDO-INICIAL' value='INVENTARIO-SALDO-INICIAL'><ListItemText primary='INVENTARIO SALDO INICIAL' /></MenuItem>
                                                                        <MenuItem key='AJUSTE-VENTA' value='AJUSTE-VENTA'><ListItemText primary='AJUSTE VENTA' /></MenuItem>
                                                                        <MenuItem key='AJUSTE-VARIANTE' value='AJUSTE-VARIANTE'><ListItemText primary='AJUSTE VARIANTE' /></MenuItem>
                                                                        <MenuItem key='AJUSTE-INVENTARIO' value='AJUSTE-INVENTARIO'><ListItemText primary='AJUSTE INVENTARIO' /></MenuItem>
                                                                    </Select>
                                                              </FormControl>
                                                          </div> 
                                           
                </div> </div>
                <div className='col-md-12'>
                    <ListTable
                        columns={columns}
                        path={path}
                        url={`existencias/HistorialMovimientos?sucursal_Id=${getDataSession('sucursal')}&entrada=true&FechaInicio=${fechaInicio}&FechaFin=${fechaFin}&almacen_id=${almacenId}&articulo_id=${articuloId}&movimiento=${tipoMov}`}
                    />
                </div>
            </div>
        </>
    );
};

export { List };
